import { render, staticRenderFns } from "./autocomplete-suggestions.vue?vue&type=template&id=6544e7aa"
import script from "./autocomplete-suggestions.vue?vue&type=script&lang=js"
export * from "./autocomplete-suggestions.vue?vue&type=script&lang=js"
import style0 from "./autocomplete-suggestions.vue?vue&type=style&index=0&id=6544e7aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports